const EditCampSkeleton = () => (
    <div>
      <div className="my-6 space-y-1 animate-pulse">
        <div className="h-6 w-1/3 bg-gray-300 rounded"></div>
        <div className="h-4 w-2/3 bg-gray-200 rounded"></div>
      </div>

      <div className="w-1/2 mb-6 animate-pulse">
        <div className="h-6 w-1/2 bg-gray-300 rounded mb-2"></div>
        <div className="h-24 bg-gray-200 rounded mb-4"></div>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 animate-pulse">
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="flex gap-4">
          <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
          <div className="h-10 w-1/2 bg-gray-200 rounded"></div>
        </div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>

        <div className="col-span-full grid gap-4 grid-cols-4">
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
          <div className="h-10 bg-gray-200 rounded"></div>
        </div>

        <div className="col-span-full h-40 bg-gray-200 rounded mt-4"></div>
      </div>

      <hr className="my-6"/>

      <div className="h-6 w-1/2 bg-gray-300 rounded mb-4 animate-pulse"></div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 animate-pulse">
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      <hr className="my-6"/>

      <div className="h-6 w-1/2 bg-gray-300 rounded mb-4 animate-pulse"></div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 animate-pulse">
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      <hr className="my-6"/>
      <div className="h-6 w-1/2 bg-gray-300 rounded mb-4 animate-pulse"></div>
      <div className="gap-2 mb-2 mt-1 flex overflow-x-auto animate-pulse">
        <div className="h-24 w-24 bg-gray-200 rounded"></div>
        <div className="h-24 w-24 bg-gray-200 rounded"></div>
        <div className="h-24 w-24 bg-gray-200 rounded"></div>
      </div>

      <div className="h-6 w-1/2 bg-gray-300 rounded my-6 animate-pulse"></div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 animate-pulse">
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>

      <div className="h-6 w-1/2 bg-gray-300 rounded my-6 animate-pulse"></div>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-3 animate-pulse">
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
        <div className="h-10 bg-gray-200 rounded"></div>
      </div>
    </div>
);

export default EditCampSkeleton
